import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberShort'
})
export class NumberShortPipe implements PipeTransform {

    transform(num: number): any {
        if (isNaN(num)) { return 0; } // will only work value is a number
        if (num === null) { return 0; }
        if (num === 0) { return 0; }
        if (num < 1000) { return num; }
        if (!Number.isFinite(num)) { return 0; }
        let abs = Math.abs(num);
        const rounder = Math.pow(10, 1);
        const isNegative = num < 0; // will also work for Negetive numbers
        let key = '';

        const powers = [
            {key: 'Q', value: Math.pow(10, 15)},
            {key: 'T', value: Math.pow(10, 12)},
            {key: 'B', value: Math.pow(10, 9)},
            {key: 'M', value: Math.pow(10, 6)},
            {key: 'K', value: 1000}
        ];
        for (let i = 0; i < powers.length; i++) {
            let reduced = abs / powers[i].value;
            reduced = Math.round(reduced * rounder) / rounder;
            if (reduced >= 1) {
                abs = reduced;
                key = powers[i].key;
                break;
            }
        }
        const ret = (isNegative ? '-' : '') + abs + key;
        return ret ? ret : '0';
    }
}
